import React from "react"

import TasksView_Column from "../../../../../model2/column/column"
import {
    AggregateFunctionLabel,
    AggregateFunctionType
} from "../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldPercentage_AggregateCell"
const debug = false

export default function FieldPercentage_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value)
    const value = isValid ? props.value : null

    let decimalPlaces = 0
    if (props.column.isCustomField) {
        decimalPlaces = props.column.customField?.params.decimalPlaces || 0
    }

    const valueLabel = typeof value === 'number' ? value.toFixed(decimalPlaces) : parseFloat(value).toFixed(decimalPlaces);

    let noDataLabel;
    switch (props.column.aggregateFunction) {
        case AggregateFunctionType.SUM:
            noDataLabel = ''
            break

        default:
            noDataLabel = props.column.aggregateFunction ?
                AggregateFunctionLabel[props.column.aggregateFunction]
                : ''
            break
    }

    const options = props.column.field?.getAggregateOptions()

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {value}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <>
                    <div className="aggregate-label">
                        {AggregateFunctionLabel[props.column.aggregateFunction!]}:
                    </div>
                    <div className="aggregate-value aggregate-number">
                        {valueLabel} %
                    </div>
                </>}

            {!isValid &&
                <div className="aggregate-value aggregate-no-data">
                    {noDataLabel}
                </div>}
        </AggregateShellComponent>
    )
}
